import { useEffect, useState } from "react";
import { GetBadgeData } from "../../lib/data";
import EditBadgeUi from "../../ui/badgeUi/editBadgeUi";
import i18n from "../../lib/i18n";
import { useTranslation } from "react-i18next";
import { ThreeDot } from "react-loading-indicators";

export default function Badge() {
    const [data, setData] = useState(null);
    const { t } = useTranslation();

    useEffect(() => {
        handleApi();
    }, []);

    const handleApi = async () => {
        const result = await GetBadgeData();
        setData(result || {});
    };

    if (!data) {
        return (
            <div className="flex justify-center items-center h-[25rem]">
                <ThreeDot variant="bounce" color="#D06421" size="large" text="" textColor="" />
            </div>
        );
    }

    return (
        <div className="p-5 mx-6 my-3 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">
                    {t("edit_page_title.badge") || "Badge Settings"}
                </h1>
                <EditBadgeUi data={data} handleApi={handleApi} />
            </div>
        </div>
    );
};
